<template>
  <div class="l-page l-page--message-edit">
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">ユニークキー配信の確認</div>
        </div>
        <div class="c-progress">
          <ul class="c-progress-list">
            <li class="c-progress-list__item">配信内容の作成</li>
            <li class="c-progress-list__item is-current">配信内容の確認</li>
            <li class="c-progress-list__item">設定完了</li>
          </ul>
        </div>
      </div>

      <div v-if="!message" class="l-main-content">
        <div class="c-loader c-loader"></div>
      </div>
      <template v-else>
        <div class="l-main-content">
          <div class="p-message-edit-confirm p-message-edit-confirm--details">
            <div class="c-title">
              <div class="c-title__text u-fs24">配信先</div>
            </div>
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">ユニークキーリスト</div>
                <div class="p-message-edit-confirm__text">
                  <template v-if="list">{{ list.list_name }}（{{ Number(list.key_count).toLocaleString() }} キー）</template>
                  <template v-else>-</template>
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">配信対象数</div>
                <div class="p-message-edit-confirm__text">
                  <span v-if="reach" class="unique-key-confirm__num">{{ reach.reach_count.toLocaleString() }} 件</span>
                  <span v-else>{{ reachFailed ? '取得できませんでした' : '確認しています…' }}</span>
                  （現時点・有効な端末のみ）
                  <p v-if="reach && reach.reach_count === 0" class="unique-key-confirm__warning">
                    現在このリストに届く端末がありません。配信を確定しても、配信日時に届く端末が無ければ送信されません。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="l-main-content">
          <div class="p-message-edit-confirm p-message-edit-confirm--preview">
            <div class="c-title c-title--left">
              <div class="c-title__text u-fs24">配信内容</div>
              <div class="c-text u-fs--s">プレビューと実際の配信されるメッセージ表示は異なることがあります</div>
            </div>
            <div class="p-message-preview-list">
              <div class="p-message-preview-list__block">
                <div class="p-message-preview__title">
                  <div class="c-text u-text-bold">PCでの配信例</div>
                </div>
                <message-preview
                  :title="message.message_title"
                  :text="message.message_text"
                  :url="message.click_url"
                  :icon-url="message.icon_url"
                  :large-image-url="message.large_image_url"
                  :has-button-a="message.use_action_button_a == 1"
                  :has-button-b="message.use_action_button_b == 1"
                  :action-button-text-a="message.action_button_text_a"
                  :action-button-url-a="message.action_button_url_a"
                  :action-button-text-b="message.action_button_text_b"
                  :action-button-url-b="message.action_button_url_b"
                />
              </div>
              <div class="p-message-preview-list__block">
                <div class="p-message-preview__title">
                  <div class="c-text u-text-bold">スマホでの配信例</div>
                </div>
                <message-preview-sp
                  :title="message.message_title"
                  :text="message.message_text"
                  :url="message.click_url"
                  :icon-url="message.icon_url"
                  :large-image-url="message.large_image_url"
                  :badge-url="message.badge_image_url"
                  :has-button-a="message.use_action_button_a == 1"
                  :has-button-b="message.use_action_button_b == 1"
                  :action-button-text-a="message.action_button_text_a"
                  :action-button-url-a="message.action_button_url_a"
                  :action-button-text-b="message.action_button_text_b"
                  :action-button-url-b="message.action_button_url_b"
                />
              </div>
            </div>
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">管理用タイトル</div>
                <div class="p-message-edit-confirm__text">{{ message.message_name }}</div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">タイトル</div>
                <div class="p-message-edit-confirm__text">{{ message.message_title }}</div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">本文</div>
                <div class="p-message-edit-confirm__text">{{ message.message_text }}</div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">遷移先URL</div>
                <div class="p-message-edit-confirm__text unique-key-confirm__url">{{ message.click_url }}</div>
              </div>
              <div v-if="message.use_action_button_a == 1" class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">ボタン1</div>
                <div class="p-message-edit-confirm__text unique-key-confirm__url">
                  {{ message.action_button_text_a }}：{{ message.action_button_url_a }}
                </div>
              </div>
              <div v-if="message.use_action_button_b == 1" class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">ボタン2</div>
                <div class="p-message-edit-confirm__text unique-key-confirm__url">
                  {{ message.action_button_text_b }}：{{ message.action_button_url_b }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="l-main-content">
          <div class="p-message-edit-confirm p-message-edit-confirm--details">
            <div class="c-title">
              <div class="c-title__text u-fs24">配信設定</div>
              <div v-if="isImmediate" class="p-message-edit-confirm__atention-text">
                注意：即時配信は、「この内容で配信する」ボタンを押すとすぐに配信されます。
              </div>
            </div>
            <div class="p-message-edit-confirm-list">
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">プッシュメッセージの動作</div>
                <div class="p-message-edit-confirm__text">
                  {{ message.require_interaction == 1 ? 'ユーザーがアクションを起こすまで表示' : '一定時間後に自動最小化' }}
                </div>
              </div>
              <div class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">配信の設定</div>
                <div class="p-message-edit-confirm__text">{{ isImmediate ? '即時配信' : '予約配信' }}</div>
              </div>
              <div v-if="!isImmediate" class="p-message-edit-confirm-list__item">
                <div class="p-message-edit-confirm__title">配信される日時</div>
                <div class="p-message-edit-confirm__text">{{ getDisplayDateTime(message.send_start_date) }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="unique-key-confirm-actions">
          <template v-if="isDraft">
            <a class="c-btn c-btn--gray u-w200 u-h50" :href="editUrl">
              <p class="c-btn__text">修正する</p>
            </a>
            <button
              type="button"
              class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
              :class="{ 'is-loading': isSetting }"
              :disabled="isSetting"
              @click="onSetClick"
            >
              <p class="c-btn__text">この内容で配信する</p>
            </button>
          </template>
          <p v-else class="unique-key-confirm__done">この配信は確定済みです。</p>
        </div>
      </template>
    </main>

    <control-modal
      ref="refCompleteModal"
      classes="c-modal--result"
      :body="completeMessage"
      cancel-button-label="配信一覧へ"
      :can-click-outside="false"
      :is-active="isComplete"
      :on-close-click="onCompleteClose"
      :on-cancel-click="onCompleteClose"
    />

    <error-modal :is-active="errorMessage !== ''" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
    messageId: Number,
  },
  data() {
    return {
      message: null,
      list: null,
      version: null,
      reach: null,
      reachFailed: false,
      isSetting: false,
      isComplete: false,
      errorMessage: '',
    };
  },
  computed: {
    isDraft: function () {
      return this.message.deliver_status == 0;
    },
    isImmediate: function () {
      return this.message.delivery_type == 4;
    },
    editUrl: function () {
      return '/coins-admin/unique-key-message/add?message_id=' + this.messageId;
    },
    completeMessage: function () {
      if (!this.message) {
        return '';
      }
      return this.isImmediate
        ? 'ユニークキー配信を登録しました。まもなく配信が始まります。'
        : `ユニークキー配信を登録しました。${this.getDisplayDateTime(this.message.send_start_date)} に配信します。`;
    },
  },
  mounted: function () {
    this.loadMessage();
  },
  methods: {
    loadMessage: function () {
      axios
        .get('/api/unique-key-message/get', { params: { message_id: this.messageId } })
        .then((res) => {
          this.message = res.data.message;
          this.list = res.data.list;
          this.version = res.data.version;
          this.reach = null;
          this.reachFailed = false;
          if (this.list) {
            this.loadReachCount();
          }
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.errorMessage = '配信内容の取得に失敗しました。再度お試しください。';
        });
    },
    loadReachCount: function () {
      const listId = this.list.list_id;
      axios
        .get('/api/unique-key-list/reach-count', { params: { list_id: listId }, timeout: 65000 })
        .then((res) => {
          // 取得中に下書きを取り直して配信先リストが変わった場合は古い結果を捨てる
          if (this.list && listId === this.list.list_id) {
            this.reach = res.data;
          }
        })
        .catch((error) => {
          this.handleHttpError(error);
          if (this.list && listId === this.list.list_id) {
            this.reachFailed = true;
          }
        });
    },
    onSetClick: function () {
      if (this.isSetting) {
        return;
      }
      this.isSetting = true;
      axios
        .post('/api/unique-key-message/set', { message_id: this.messageId, version: this.version })
        .then((res) => {
          this.isSetting = false;
          if (res.data.result === 'OK') {
            this.isComplete = true;
            return;
          }
          this.errorMessage = res.data.message;
          // 別のタブで変更されていたら、変更後の内容を表示し直して確認してもらう
          if (res.data.reload) {
            this.loadMessage();
          }
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.isSetting = false;
          this.errorMessage = '配信の登録に失敗しました。再度お試しください。';
        });
    },
    onCompleteClose: function () {
      location.href = '/coins-admin/unique-key-message';
    },
    onCloseErrorModal: function () {
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped>
.unique-key-confirm__num {
  font-weight: bold;
  font-variant-numeric: tabular-nums;
}
.unique-key-confirm__warning {
  color: #d9534f;
  font-size: 13px;
  margin-top: 6px;
}
.unique-key-confirm__url {
  word-break: break-all;
}
.unique-key-confirm-actions {
  display: flex;
  justify-content: center;
  gap: 24px;
  width: 100%;
  padding: 32px 0 64px;
}
.unique-key-confirm__done {
  color: #666;
}
</style>
